export const NO_RESULTS = 0
export const CAMPAIGN_STATUSES = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  LIVE: 'Live',
  HIDDEN: 'Hidden',
  EXPIRED: 'Expired',
  DRAFT: 'Draft'
}
export enum CampaignsListColumns {
  'ID' = 'ID',
  'CATEGORY' = 'Category',
  'TITLE' = 'Title',
  'FEATURED_POSITION' = 'Featured Position',
  'INCLUDED_SEGMENTS' = 'Included Segments',
  'TRANSLATIONS' = 'Translations',
  'STATUS' = 'Status',
  'LAUNCH_DATE' = 'Launch Date'
}
export const CAMPAIGN_TYPES = {
  TRANSACTIONAL: 'TRANSACTIONAL',
  PROVIDER_SIGNUP: 'PROVIDER_SIGNUP',
  SURVEY: 'SURVEY',
  FRIEND_REFERRAL: 'FRIEND_REFERRAL',
  ACTION: 'ACTION',
  QUEST: 'QUEST',
  EXTERNAL_SURVEY: 'EXTERNAL_SURVEY',
  LOCATION: 'LOCATION',
  CONNECT: 'CONNECT',
  STREAK: 'STREAK',
  MULTI_TRIP: 'MULTI_TRIP',
  REDEMPTION: 'REDEMPTION',
  TIER: 'TIER',
  CONDITION: 'CONDITION'
}
export const CAMPAIGN_TYPES_FOR_CREATION = [
  'Action',
  'Condition',
  'Connect',
  'External Survey',
  'Location',
  'Multi-Behavior',
  'Redemption',
  'Streak',
  'Tier',
  'Transactional'
]
export const CAMPAIGNS_FILTERS_KEYS = {
  TYPES: 'selectedTypes',
  STATUSES: 'selectedStatuses',
  CATEGORIES: 'selectedCategories',
  SEARCH: 'search'
}
export const CAMPAIGN_DETAILS_TABS = [
  'Settings',
  'Segments',
  'Notes',
  'Users Participating',
  'Translations'
]
export const CAMPAIGN_DETAILS_MORE_MENU_ITEMS = ['Update Status', 'Duplicate']
export const DRAFT_CAMPAIGN_DETAILS_MORE_MENU_ITEMS = ['Delete', 'Duplicate']
export const BEHAVIOR = 'BEHAVIOR'
export const SURVEY = 'SURVEY'
export const CAMPAIGN_DETAILS_LEFT_SECTION_ITEMS = {
  Name: 'Name',
  SubHeader: 'Sub-header 1',
  SubTitle: 'Sub-header 2'
}
export const CAMPAIGN = 'Campaign'
export const FIXED_BUCKET_START_TIME_DETAIL_CAMPAIGN_TYPES = [
  CAMPAIGN_TYPES.TRANSACTIONAL,
  CAMPAIGN_TYPES.LOCATION,
  CAMPAIGN_TYPES.STREAK,
  CAMPAIGN_TYPES.MULTI_TRIP,
  CAMPAIGN_TYPES.REDEMPTION,
  CAMPAIGN_TYPES.TIER,
  CAMPAIGN_TYPES.CONDITION
]
export const CAMPAIGN_TYPES_WITH_BUCKET_LIMIT_OPTIONAL = [CAMPAIGN_TYPES.ACTION]
export const TRANSACTION_AGGREGATE_AND_FILTER_DETAIL_CAMPAIGN_TYPES = [
  CAMPAIGN_TYPES.TRANSACTIONAL,
  CAMPAIGN_TYPES.LOCATION,
  CAMPAIGN_TYPES.CONDITION
]
export const PRODUCT_ACTIVATION = 'ProductActivation'
export const SQL_FILTER_VALUE = 'SqlFilter'
export const EQUAL = '='
export const MULTI_TRIP_TYPE = {
  FIRST_TRIP: 'FIRST_TRIP',
  SECOND_TRIP: 'SECOND_TRIP'
}
export const INCREMENT_COUNTER = 1
export const NO_LIMITS = 'No Limits'
export const ONE_TIME_EARN = '1 Time Earning'
export const PER = 'per'
export const ANY_DAY = 'Any day'
export const FROM = 'From '
export const TO = ' To: '
export const ANY_TIME = 'Any time'
export const ANY_LOCATION = 'Any location'
export const BEHAVIORS = 'BEHAVIORS'
export const TEXT_COLORS = {
  GRAY: 'text-gray-500',
  RED: 'text-red-500',
  GREEN: 'text-green-500'
}
export const TIER = 'Tier'
export const BEHAVIORS_TEXT = 'Behaviors'
export const ANSWERS = 'Answers'
export const PROVIDERID = 'ProviderID'
export const BEHAVIOR_FROM_PROVIDER = 'Behavior from Provider'
export const SURVEY_ANSWER = 'Survey Answer'
export const ANY_PRODUCT = 'Any product'
export const MULTI_TRIP_BEHAVIOR_NUM = {
  ONE: 1,
  TWO: 2
}
export const SETTINGS = 'Settings'
export const MULTI_TRIP_BEHAVIOR_TEXT = 'Behavior'
export const UPDATE_STATUS = 'Update Status'
export const DELETE = 'Delete'
export const CAMPAIGN_STATUS_SECTIONS = {
  VISIBILITY: {
    TITLE: 'Visibility Status',
    DESCRIPTION: 'Defines if the campaign is visible or not on Rewards.'
  },
  EARNING_CAPABILITY: {
    TITLE: 'Earning Capability',
    DESCRIPTION:
      'Defines if the campaign is able to distribute the Reward to the Users.'
  }
}
export const CAMPAIGN_NOTES = {
  GENERAL: 'general',
  RESULTS: 'results'
}
export const GENERAL_NOTES = 'General Notes'
export const RESULTS_NOTES = 'Results and Findings'

export const CAMPAIGN_SEGMENTS_TAB_TEXT = {
  INCLUDED: {
    TITLE: 'Segments that can see the Campaign',
    DESCRIPTION:
      'Only the users that are included in at least one of these segments, are going to be able to see and participate in this campaign.'
  },
  EXCLUDED: {
    TITLE: 'Segments that are excluded from the Campaign',
    DESCRIPTION:
      'If a user is included in any of these segments, they will not be able to see and participate in this campaign.'
  }
}
export const CAMPAIGNS_TABS_INDEX = {
  SETTINGS: 0,
  SEGMENTS: 1,
  NOTES: 2,
  USERS_PARTICIPATION: 3,
  TRANSLATIONS: 4
}
export const CONNECT_CTA_ACTION = {
  redirect: {
    text: 'Redirect to Connect Apps Section',
    value: 'redirect'
  },
  open: {
    text: 'Open Connection Component',
    value: 'open'
  },
  redirectToUrl: {
    text: 'Redirect to URL',
    value: 'redirectToUrl'
  }
}
export const MULTI_TRIP_BEHAVIOR_ORDER = {
  ANY: 'Any Order',
  SPECIFIC: 'Specific Order'
}
export const CREATE_OR_UPDATE_CAMPAIGNS_TABS_INDEX = {
  INFORMATION: 0,
  OPTIONS: 1,
  REWARD_SETTINGS: 2
} as const
export const TRANSACTION_CAMPAIGN = 'Transactional'
export const ACTION_CAMPAIGN = 'Action'
export const REDEMPTION_CAMPAIGN = 'Redemption'
export const EXTERNAL_SURVEY_KEYWORD = 'survey'
export const CONNECT_CAMPAIGN = 'Connect'
export const LOCATION_CAMPAIGN = 'Location'
export const STREAK_CAMPAIGN = 'Streak'
export const TIER_CAMPAIGN = 'Tier'
export const MULTI_BEHAVIOR_CAMPAIGN = 'Multi-Behavior'
export const CONDITION_CAMPAIGN = 'Condition'
export const CREATE_OR_UPDATE_CAMPAIGN_TABS = [
  'Information',
  'Options',
  'Rewards Settings'
]
export const CREATE_OR_UPDATE_CAMPAIGN_TITLES = {
  CARD_INFO: 'Card Information',
  CARD_DETAIL: 'Card Detail',
  CAMPAIGN_LAYOUT: 'Campaign Layout',
  NAME: 'Name',
  TITLE: 'Title',
  SUBHEADER1: 'Sub-header 1',
  SUBHEADER2: 'Sub-header 2',
  DESCRIPTION: 'Description',
  CAMPAIGN_IMAGE: 'Image',
  CAMPAIGN_ICON: 'Icon (optional)',
  CTA_NAME: 'Label',
  CTA_LINK: 'Link',
  CTA_SURVEY_ID: 'Survey ID',
  CATEGORY: 'Category',
  UI_POSITION: 'Campaign UI Position',
  IS_FEATURED: 'Display as Featured Campaign?',
  FEATURED_UI_POSITION: 'Featured UI Position',
  CAMPAIGN_DATES: 'Campaign Dates',
  CAMPAIGN_POINTS_DISTRIBUTION: 'Campaign Points Distribution',
  SEGMENTS: 'Segments',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  START_REWARD_DATE: 'Start Rewarding Date',
  HAS_POINTS_EXPIRY_DATE: 'Expire Points after the End of the Campaign?',
  POINTS_EXPIRY_DATE: 'Points Expiry Date',
  HAS_NO_SPENDING_EXPIRY: 'Expire Earnings after not taking an action:',
  SELECT_REQUIRED_ACTION_TYPE: 'Select the type of action required',
  NO_SPENDING_TIME:
    'Time (in seconds) to check if the user completed the action after receiving the earning',
  NO_SPENDING_CAMPAIGN_ID: 'Campaign required to be Earned',
  POINTS_PER_EARNING: 'Points per Earning',
  TOTAL_POINTS_REWARD: 'Total Points to Reward',
  AVAILABLE_SEGMENTS: 'Segments that will be able to see the Campaign',
  EXCLUDED_SEGMENTS: 'Segments that will be excluded from seeing the Campaign',
  CAMPAIGN_EARNING_LIMITS: 'Earning Limits',
  CAMPAIGN_BEHAVIORS_FILTER: 'Behaviors Filter',
  EARNING_LIMIT_COUNT: 'Count',
  EARNING_LIMIT_UNIT: 'Unit',
  MAX_EARN: 'Max. times a user can earn the campaign',
  MAX_EARN_IN_BUCKET: 'Max. times can be earned by a user in the time frame',
  REWARD_CAMPAIGN_AFTER_VALUE: 'Value',
  REWARD_CAMPAIGN_AFTER_METHOD: 'Method',
  INVOICE_PROVIDER: 'Invoice Provider',
  PROVIDER: 'Provider Required to Connect',
  TRANSACTION_FILTER_TYPE: 'Type of Transactional Filter',
  FILTER_FROM_LIST: 'Select a filter from the list',
  NO_FILTER: 'Don’t apply filter',
  SQL_FILTER: 'SQL filter',
  CAMPAIGN_TRANSACTIONAL_FILTER: 'Transactional Filter',
  SELECT_OPERATOR: 'Select Operator',
  HAS_SPECIFIC_PRODUCT: 'Select a specific Product',
  HAS_SPECIFIC_DAYS: 'Select a specific day when the behaviors needs to happen',
  HAS_SPECIFIC_TIMES:
    'Select a specific time frame when the behaviors needs to happen',
  CAMPAIGN_BADGES: 'Campaign Badges',
  BADGE_LABEL: 'Badge Label',
  BADGE_ICON: 'Select Badge Icon',
  HAS_EARNING_LIMIT: 'Set Earning Limits for the Campaign',
  BEHAVIOR_TYPE: 'Select the Source of the Behaviors',
  PROVIDER_FILTER: 'Provider App Connection',
  PARTNER_FILTER: 'Partner Achievement',
  ACTION_TYPE: 'Action Type',
  SOURCE_OF_BEHAVIORS: 'Source of the Behaviors',
  PARTNER: 'Partner Required',
  REWARD_TYPE: 'Reward Type',
  VALID_OFFERS: 'Valid Offers',
  CAMPAIGN_SURVEY_SETUP: 'Survey Setup',
  REQUIRE_PROVIDER: 'Require a Provider Connection',
  EXTERNAL_SURVEY_CTA_NAME: 'Button Label',
  EXTERNAL_SURVEY_CTA_LINK: 'Survey Form ID',
  CAMPAIGN_CONNECT_SETUP: 'Connection Setup',
  CONNECT_CTA_ACTION: 'Action of the Button',
  LOCATION_INFO: 'Location Information',
  STREAK_LEVELS_NUM: 'Number of Levels',
  CAMPAIGN_LEVELS_DEFINITION: 'Levels Definition',
  HAS_SPECIFIC_LOCATION: 'Select a specific Location',
  HAS_TIME_DISTINCT: 'Time distinct',
  TIME_DISTINCT_QUANTITY: 'Quantity',
  TIME_DISTINCT_UNIT: 'Duration',
  NUM_OF_TIERS: 'Number of Tiers',
  TIER_BEHAVIOR_TYPE: 'Type of Behavior Required',
  TIER_BEHAVIOR_FILTER: 'Type of Behaviors Filter',
  TIER_BEHAVIOR_SQLFILTER: 'SQL Query',
  TIER_BEHAVIOR: 'BEHAVIOR',
  TIER_SURVEY: 'SURVEY',
  CAMPAIGN_BEHAVIORS_FROM_PROVIDER: 'Behavior from Provider',
  CAMPAIGN_SURVEY_ANSWER: 'Survey Answer',
  MULTI_REQUIRED_COUNT: 'Time',
  MULTI_REQUIRED_UNIT: 'Unit',
  MULTI_IGNORE_BEHAVIOR_ORDER: 'Behaviors completed can be in any order.',
  MULTI_TRIP_CAMPAIGN_BEHAVIOR_ONE: 'Behavior 1',
  MULTI_TRIP_CAMPAIGN_BEHAVIOR_TWO: 'Behavior 2',
  SEGMENT_USERS_ON_SURVEY_ANSWERS: 'Segment User based on Answers',
  EARNING_CONDITIONS: 'Earning Conditions',
  NO_EARNINGS_CONDITIONS_CREATED: 'There are no Earnings Conditions Created.',
  PRESS_TO_CREATE_CONDITION: 'Press on the button to create a new condition.',
  CREATE_CONDITION: 'Create Condition',
  LOCATION_SNAPSHOT: 'Location Snapshot',
  HAS_PARTICIPATION_LIMIT: 'Limit Participation',
  PARTICIPATION_QUANTITY: 'Quantity',
  PARTICIPATION_UNIT: 'Unit'
}
export const CREATE_OR_UPDATE_CAMPAIGN_SUB_TITLES = {
  CARD_INFO: 'This information will be displayed on the Campaign List.',
  CARD_DETAIL:
    'Displayed when the user presses on the Campaign Card to open the detail view.',
  CAMPAIGN_LAYOUT:
    'Defines the position of the Campaign Card inside the Earn section of Rewards.',
  UI_POSITION: 'Press on the Reorder option to set a new position',
  CAMPAIGN_DATES:
    'The day and time selections on this fields are based on UTC Time.',
  CAMPAIGN_POINTS_DISTRIBUTION:
    'Number of points the user will get per earnings, and total number of points the campaign will grant to all of the users.',
  SEGMENTS:
    'Select the list of specific segment that will be able to see this campaign. It can also be set to be available to All Users. For the excluded segments, any user that is part of this segments won’t be able to see and participate on this campaign.',
  CAMPAIGN_EARNING_LIMITS:
    'Select a time frame when the user needs to complete the desired behavior to earn the campaign, and within that time, the max amount of behaviors that will be rewarded.',
  CAMPAIGN_BEHAVIORS_FILTER:
    'This setup will define what behaviors are valid to be considered when evaluating the campaign.',
  ACTION_CAMPAIGN_BEHAVIORS_FILTER:
    'The following defines what type of behaviors are going to be included to reward the users. Based on the selection of each fields, new information may be required.',
  CAMPAIGN_TRANSACTIONAL_FILTER:
    'The following defines what type of behaviors are going to be included to reward the users. Based on the selection of each fields, new information may be required.',
  CAMPAIGN_SQL_FILTER:
    'Enter the SQL Query that will be use to filter the behaviors to reward the users during the campaign evaluation.',
  CAMPAIGN_BADGES:
    'List of badges with highlighted information that will be displayed on the Campaign Detail view.',
  SOURCE_OF_BEHAVIORS:
    'This setup will define what behaviors are valid to be considered when evaluating the campaign.',
  CAMPAIGN_SURVEY_SETUP:
    'Select the Survey that is going to be connected to the Campaign.',
  CAMPAIGN_CONNECT_SETUP:
    'Select the Provider required to Connect to earn the campaign, and how the Connect Component will behave.',
  CAMPAIGN_LEVELS_DEFINITION:
    'For each of the levels, provide the number of behaviors required to receive the reward, and the points to get.',
  CAMPAIGN_BEHAVIORS_FROM_PROVIDER:
    'This setup will define what behaviors are valid to be considered when evaluating the campaign, and the Tier Level requirements.',
  CAMPAIGN_SURVEY_ANSWER:
    'This setup will define what is the survey linked to the campaign, and the Tier Level requirements.',
  MULTI_TRIP_CAMPAIGN_BEHAVIOR_ONE:
    'This setup will define what is required for the first behavior to be valid when evaluating the campaign.',
  MULTI_TRIP_CAMPAIGN_BEHAVIOR_TWO:
    'This setup will define what is required for the second behavior to be valid when evaluating the campaign.',
  SEGMENT_USERS_ON_SURVEY_ANSWERS:
    'Provide the Question and Answer the user must select to be included on the desired segment.',
  NEW_EARNING_CONDITION: 'New Earning Condition'
}
export const CREATE_OR_UPDATE_CAMPAIGN_KEYS = {
  NAME: 'name',
  TITLE: 'title',
  SUBHEADER1: 'subHeader1',
  SUBHEADER2: 'subHeader2',
  DESCRIPTION: 'description',
  CAMPAIGN_IMAGE: 'campaignsImageID',
  CAMPAIGN_ICON: 'campaignsIconID',
  CAMPAIGN_LOCATION_SNAPSHOT: 'campaignsLocationSnapShotID',
  CATEGORY: 'category',
  UI_POSITION: 'uiPosition',
  CTA_NAME: 'ctaName',
  CTA_LINK: 'ctaLink',
  IS_FEATURED: 'isFeatured',
  FEATURED_UI_POSITION: 'featuredUi',
  START_DATE: 'startTimestampUTC',
  END_DATE: 'endTimestampUTC',
  START_REWARD_DATE: 'fixedBucketStartTime',
  HAS_POINTS_EXPIRY_DATE: 'hasExpiryDate',
  POINTS_EXPIRY_DATE: 'pointExpiryDate',
  HAS_NO_SPENDING_EXPIRY: 'hasNoSpendingExpiry',
  NO_SPENDING_EXPIRY: 'noSpendingExpiry',
  NO_SPENDING_EXPIRY_TYPE: 'NoSpendingExpiryType',
  NO_SPENDING_CAMPAIGN_ID: 'NoSpendingExpiryCampaignID',
  POINTS_PER_EARNING: 'pointEarned',
  TOTAL_POINTS_REWARD: 'totalPoint',
  AVAILABLE_SEGMENTS: 'availableSegments',
  EXCLUDED_SEGMENTS: 'excludeSegments',
  EARNING_LIMIT_COUNT: 'earningCount',
  EARNING_LIMIT_UNIT: 'earnUnit',
  MAX_EARN: 'earnMax',
  MAX_EARN_IN_BUCKET: 'bucketRepetition',
  REWARD_CAMPAIGN_AFTER_VALUE: 'aggregateValue',
  REWARD_CAMPAIGN_AFTER_METHOD: 'aggregateMethod',
  PROVIDER: 'provider',
  TRANSACTION_FILTER_TYPE: 'filterType',
  FILTER_VALUE: 'filterValue',
  FILTER: 'filter',
  OPERATOR: 'operator',
  HAS_SPECIFIC_PRODUCT: 'hasSpecificProduct',
  HAS_SPECIFIC_DAYS: 'hasSpecificDays',
  HAS_SPECIFIC_TIMES: 'hasSpecificTimes',
  SPECIFIC_DAYS: 'specificDays',
  SPECIFIC_TIMES: 'specificTimes',
  SPECIFIC_START_TIME: 'specificStartTime',
  SPECIFIC_END_TIME: 'specificEndTime',
  BADGE_LABEL: 'badgeLabel',
  BADGE_ICON: 'badgeIcon',
  HAS_EARNING_LIMIT: 'hasLimit',
  BEHAVIOR_TYPE: 'behaviorType',
  ACTION_TYPE: 'actionType',
  PARTNER: 'partner',
  REWARD_TYPE: 'rewardType',
  VALID_OFFERS: 'validOffers',
  REQUIRE_PROVIDER: 'isProviderConnectRequired',
  CONNECT_CTA_ACTION: 'CtaAction',
  GEO_JSON_DESCRIPTION: 'geoJsonDescription',
  GEO_JSON_START_LOCATION: 'geoJsonStartLocation',
  GEO_JSON_END_LOCATION: 'geoJsonEndLocation',
  GEO_JSON_RELATIONSHIP: 'geoJsonRelationship',
  STREAK_LEVELS_NUM: 'numberOfLevels',
  HAS_SPECIFIC_LOCATION: 'hasSpecificLocation',
  HAS_TIME_DISTINCT: 'hasTimeDistinct',
  TIME_DISTINCT_QUANTITY: 'timeDistinctCount',
  TIME_DISTINCT_UNIT: 'timeDistinctUnit',
  NUM_OF_TIERS: 'numberOfTiers',
  TIER_BEHAVIOR_TYPE: 'tierBehaviorType',
  TIER_BEHAVIOR_FILTER: 'tierBehaviorFilter',
  TIER_BEHAVIOR_SQL_FILTER_VALUE: 'tierBehaviorSQLFilter',
  MULTI_REQUIRED_COUNT: 'multiRequiredCount',
  MULTI_REQUIRED_UNIT: 'multiRequiredUnit',
  MULTI_TIME_POINT_FROM_FIRST_TRIP: 'timePointFromFirstTrip',
  MULTI_TIME_POINT_FROM_SECOND_TRIP: 'timePointFromSecondTrip',
  MULTI_IGNORE_BEHAVIOR_ORDER: 'ignoreBehaviorOrder',
  MULTI_PROVIDER_FOR_FIRST: 'providerForFirst',
  MULTI_PROVIDER_FOR_SECOND: 'providerForSecond',
  MULTI_HAS_SPECIFIC_LOCATION_FOR_FIRST: 'hasSpecificLocationForFirst',
  MULTI_HAS_SPECIFIC_LOCATION_FOR_SECOND: 'hasSpecificLocationForSecond',
  MULTI_GEO_JSON_DESCRIPTION_FOR_FIRST: 'geoJsonDescriptionForFirst',
  MULTI_GEO_JSON_START_LOCATION_FOR_FIRST: 'geoJsonStartLocationForFirst',
  MULTI_GEO_JSON_END_LOCATION_FOR_FIRST: 'geoJsonEndLocationForFirst',
  MULTI_GEO_JSON_RELATIONSHIP_FOR_FIRST: 'geoJsonRelationshipForFirst',
  MULTI_GEO_JSON_DESCRIPTION_FOR_SECOND: 'geoJsonDescriptionForSecond',
  MULTI_GEO_JSON_START_LOCATION_FOR_SECOND: 'geoJsonStartLocationForSecond',
  MULTI_GEO_JSON_END_LOCATION_FOR_SECOND: 'geoJsonEndLocationForSecond',
  MULTI_GEO_JSON_RELATIONSHIP_FOR_SECOND: 'geoJsonRelationshipForSecond',
  MULTI_FILTER_TYPE_FOR_FIRST: 'filterTypeForFirst',
  MULTI_FILTER_TYPE_FOR_SECOND: 'filterTypeForSecond',
  MULTI_FILTER_VALUE_FOR_FIRST: 'filterValueForFirst',
  MULTI_FILTER_VALUE_FOR_SECOND: 'filterValueForSecond',
  MULTI_FILTER_FOR_FIRST: 'filterForFirst',
  MULTI_FILTER_FOR_SECOND: 'filterForSecond',
  MULTI_OPERATOR_FOR_FIRST: 'operatorForFirst',
  MULTI_OPERATOR_FOR_SECOND: 'operatorForSecond',
  MULTI_HAS_SPECIFIC_PRODUCT_FOR_FIRST: 'hasSpecificProductForFirst',
  MULTI_HAS_SPECIFIC_PRODUCT_FOR_SECOND: 'hasSpecificProductForSecond',
  CURRENT_ORGANIZATION_INPUT: 'currentOrganizationInput',
  CURRENT_PRODUCT_ID_INPUT: 'currentProductIDInput',
  SEGMENT_USERS_ON_SURVEY_ANSWERS: 'isSegmentUsersSelected',
  INVOICE_PROVIDER: 'invoiceProvider',
  HAS_PARTICIPATION_LIMIT: 'HasParticipationLimit',
  PARTICIPATION_QUANTITY: 'ParticipationLimitQuantity',
  PARTICIPATION_UNIT: 'ParticipationLimitUnit'
}
export const CAMPAIGN_EARNING_LIMITS_UNITS_OPTIONS = [
  {
    label: 'Day',
    value: 'DAY'
  },
  {
    label: 'Week',
    value: 'WEEK'
  },
  {
    label: 'ISO Week',
    value: 'ISO_WEEK'
  },
  {
    label: 'Month',
    value: 'MONTH'
  }
]
export const CAMPAIGN_AGGREGATES_METHOD_OPTIONS = [
  {
    label: 'Behaviors',
    value: 'Count'
  },
  {
    label: 'Distance in Km',
    value: 'DistanceInKm'
  },
  {
    label: 'Time in minutes',
    value: 'TimeInMinutes'
  },
  {
    label: 'Price',
    value: 'Price'
  }
]
export const CAMPAIGN_TRANSACTIONAL_FILTERS = [
  { value: 'FromTimestampUTC', label: 'FromTimestampUTC' },
  { value: 'ToTimestampUTC', label: 'ToTimestampUTC' },
  { value: 'Price', label: 'Price' },
  { value: 'Currency', label: 'Currency' },
  { value: 'DistanceInKm', label: 'DistanceInKm' },
  { value: 'ProviderID', label: 'ProviderID' },
  { value: 'VerticalID', label: 'VerticalID' },
  { value: 'VehicleType', label: 'VehicleType' },
  { value: 'FromLng', label: 'FromLng' },
  { value: 'FromLat', label: 'FromLat' },
  { value: 'FromAddress', label: 'FromAddress' },
  { value: 'ToLng', label: 'ToLng' },
  { value: 'ToLat', label: 'ToLat' },
  { value: 'ToAddress', label: 'ToAddress' },
  { value: 'CountryISO', label: 'CountryISO' },
  { value: 'UNLocCode', label: 'UNLocCode' },
  {
    value: 'ProductActivation',
    label: 'ProductActivation'
  }
]
export const CAMPAIGN_TRANSACTIONAL_FILTER_OPERATORS = [
  {
    label: '<',
    value: '<'
  },
  {
    label: '<=',
    value: '<='
  },
  {
    label: '=',
    value: '='
  },
  {
    label: '>=',
    value: '>='
  },
  {
    label: '>',
    value: '>'
  }
]
export const CAMPAIGN_SPECIFIC_DAYS = [
  {
    label: 'Monday',
    value: '1'
  },
  {
    label: 'Tuesday',
    value: '2'
  },
  {
    label: 'Wednesday',
    value: '3'
  },
  {
    label: 'Thursday',
    value: '4'
  },
  {
    label: 'Friday',
    value: '5'
  },
  {
    label: 'Saturday',
    value: '6'
  },
  {
    label: 'Sunday',
    value: '7'
  }
]
export const BADGE_LABEL_MAX_LIMIT = 30
export const BADGE_LIST_LIMIT = 5
export const EMPTY_LIST_LENGTH = 0
export const DAYS_OF_WEEK_MAP: { [key: string]: string } = {
  Monday: '1',
  Tuesday: '2',
  Wednesday: '3',
  Thursday: '4',
  Friday: '5',
  Saturday: '6',
  Sunday: '7'
}
export const ACTION_CAMPAIGN_EARNING_LIMITS_UNITS_OPTIONS = [
  {
    label: 'None',
    value: 'NONE'
  },
  {
    label: 'One time',
    value: 'ONETIME'
  },
  {
    label: 'Month',
    value: 'MONTH'
  }
]
export const CAMPAIGN_TRANSACTION_FILTERS_TYPES = [
  {
    key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.FILTER_FROM_LIST,
    label: 'filter-from-list'
  },
  { key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.SQL_FILTER, label: 'sql-filter' }
]
export const LOCATION_CAMPAIGN_TRANSACTION_FILTERS_TYPES = [
  {
    key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.NO_FILTER,
    label: 'no-filter'
  },
  {
    key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.FILTER_FROM_LIST,
    label: 'filter-from-list'
  },
  { key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.SQL_FILTER, label: 'sql-filter' }
]
export const CAMPAIGN_BEHAVIOR_FILTERS_TYPES = [
  {
    key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.PROVIDER_FILTER,
    label: 'provider'
  },
  { key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.PARTNER_FILTER, label: 'partner' }
]
export const CURRENTLY_IMPLEMENTED_CAMPAIGN_TYPES = [
  'Transactional',
  'Action',
  'Redemption',
  'External Survey',
  'Connect',
  'Location',
  'Streak',
  'Tier',
  'Multi-Behavior',
  'Condition'
]
export const REDEMPTION_CAMPAIGN_EARNING_LIMITS_UNITS_OPTIONS = [
  {
    label: 'Day',
    value: 'DAY'
  },
  {
    label: 'Week',
    value: 'WEEK'
  },
  {
    label: 'Month',
    value: 'MONTH'
  }
]
export const EXTERNAL_SURVEY_CAMPAIGN_EARNING_LIMITS_UNITS_OPTIONS = [
  {
    label: 'Hour',
    value: 'HOUR'
  },
  {
    label: 'Day',
    value: 'DAY'
  },
  {
    label: 'Week',
    value: 'WEEK'
  },
  {
    label: 'ISO Week',
    value: 'ISO_WEEK'
  },
  {
    label: 'Month',
    value: 'MONTH'
  }
]
export const CONNECT_CAMPAIGN_CTA_ACTION_OPTIONS = [
  {
    label: 'Redirect to Connect Apps Section',
    value: 'redirect'
  },
  {
    label: 'Open Connection Component',
    value: 'open'
  },
  {
    label: 'Redirect to URL',
    value: 'redirectToUrl'
  }
]
export const LOCATION_CAMPAIGN_AGGREGATES_METHOD_OPTIONS = [
  {
    label: 'Behaviors',
    value: 'COUNT'
  },
  {
    label: 'Distance',
    value: 'DISTANCE'
  }
]
export const CAMPAIGN_GEO_JSON_RELATIONSHIP_OPTIONS = [
  {
    label: 'OR',
    value: 'OR'
  },
  {
    label: 'AND',
    value: 'AND'
  }
]
export const CAMPAIGN_BADGE_ERROR = 'Both Icon and Label required to add badge.'
export const STREAK_CAMPAIGN_LEVELS_OPTIONS = Array.from({ length: 10 }, (
  __,
  i
) => {
  const value = (i + 1).toString()
  return { label: value, value: value }
})
export const STREAK_CAMPAIGN_UNITS_OPTIONS = [
  {
    label: 'Day',
    value: 'DAY'
  },
  {
    label: 'Week',
    value: 'WEEK'
  },
  {
    label: 'Month',
    value: 'MONTH'
  }
]
export const STREAK_LEVEL_INFO = {
  FIELDS: {
    BEHAVIORS: 'behaviors',
    POINTS: 'points'
  },
  KEYS: {
    BEHAVIORS: 'requiredLevelTripCount',
    POINTS: 'rewardLevelPoints'
  }
}
export const TIER_CAMPAIGN_NUMBER_OF_TIERS_OPTIONS = Array.from({ length: 5 }, (
  __,
  i
) => {
  const value = (i + 1).toString()
  return { label: value, value: value }
})
export const TIER_CAMPAIGN_BEHAVIORS_TYPES = [
  {
    key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.TIER_BEHAVIOR,
    label: 'Behavior from Provider'
  },
  { key: CREATE_OR_UPDATE_CAMPAIGN_TITLES.TIER_SURVEY, label: 'Survey Answer' }
]
export const TIER_CAMPAIGN_UNITS_OPTIONS = [
  {
    label: 'Day',
    value: 'DAY'
  },
  {
    label: 'Week',
    value: 'WEEK'
  },
  {
    label: 'Month',
    value: 'MONTH'
  }
]
export const TIER_PROPERTIES_INFO = {
  FIELDS: {
    BEHAVIORS: 'behaviors',
    POINTS: 'points'
  },
  KEYS: {
    BEHAVIORS: 'maxBehaviors',
    POINTS: 'tierRewardPoints'
  }
}
export const MULTI_BEHAVIOR_KEYWORD = 'multi'
export const MULTI_TRIP_CAMPAIGN_UNITS_OPTIONS = [
  {
    label: 'Day',
    value: 'DAY'
  },
  {
    label: 'Week',
    value: 'WEEK'
  },
  {
    label: 'Month',
    value: 'MONTH'
  }
]
export const MULTI_TRIP_SECOND_REQUIREMENT_UNITS_OPTIONS = [
  {
    label: 'Hours',
    value: 'hours'
  },
  {
    label: 'Minutes',
    value: 'minutes'
  },
  {
    label: 'Seconds',
    value: 'seconds'
  }
]
export const MULTI_TRIP_TIME_POINT_OPTIONS = [
  {
    label: 'FROM_TIMESTAMP',
    value: 'FROM_TIMESTAMP'
  },
  {
    label: 'TO_TIMESTAMP',
    value: 'TO_TIMESTAMP'
  }
]
export const MULTI_TRIP_BEHAVIORS_IDENTIFIERS = {
  FIRST: 'First',
  SECOND: 'Second'
}
export const DUPLICATE = 'Duplicate'
export const ALL_PRODUCTS_FROM_PROVIDER = {
  label: 'All products from this provider',
  value: 'ALL'
}
export const PRODUCT_ID = 'productID'

export const CAMPAIGN_TRANSLATIONS_COLUMN_NAME: CampaignTranslationsFields = {
  Title: 'Title',
  SubTitle: 'Sub-header 1',
  SubHeader: 'Sub-header 2',
  Description: 'Description',
  CTALabel: 'CTA Label'
}
export const START_REWARD_DATE_FIELD_DESCRIPTION =
  'To be able to save this information, we should enter the earning limits (if mandatory) on the next step'

export const AND = 'AND'
export const OR = 'OR'
export const SURVEY_SEGMENTATION_RULES_RELATIONSHIPS = [AND, OR].map((
  relationship
) => ({
  label: relationship,
  value: relationship
}))
export const QUESTION = 'Question'
export const ANSWER = 'Answer'
export const SURVEY_SEGMENTATION_GROUPING_KEY = 'ExternalSurveySegmentationID'
export const SURVEY_SEGMENTATION_TEXT = {
  TITLE: 'Segment based on Answers',
  LABEL: 'Survey Answers',
  ADD_RULE_DESCRIPTION:
    'Manage the rules to add a user to a specific segment based on the answers from the survey.',
  DETAIL_VIEW_DESCRIPTION:
    'Rules to Add a User to a specific Segment based on the answers from the Survey.'
}
export const CAMPAIGN_TRANSLATIONS_KEYS = [
  'Title',
  'Description',
  'CTALabel',
  'SubHeader',
  'SubTitle'
]

export const TRACK_CAMPAIGN_EVENTS = {
  CREATE: 'Create New Campaign',
  EDIT: 'Update Campaign',
  DRAFT: 'Save as a Draft',
  DUPLICATE: 'Duplicate Campaign'
}

export const INVOICE_PROVIDER = 'Invoice Provider'

export const CAMPAIGN_PREVIEW_PROGRESS_FALLBACK = 0
export const CAMPAIGN_TIER_PREVIEW_PROGRESS_TYPE = {
  TRIPS: 'trips',
  SURVEYS: 'surveys'
}
export const CAMPAIGN_STREAK_PREVIEW_PROGRESS_DAYS = [
  'M',
  'T',
  'W',
  'T',
  'F',
  'S',
  'S'
]
export const CAMPAIGN_STREAK_PREVIEW_PROGRESS_LAST_IDX = 6
export const CAMPAIGN_STREAK_PREVIEW_PROGRESS_TEXT = {
  DAYS_LEFT: 'X Days Left',
  NEXT_TARGET: 'Next streak target: Next Monday',
  STREAK_TARGET: 'Streak target:'
}

export const CAMPAIGN_INVALID_GEO_JSON_ERRORS = {
  NO_DESCRIPTION: 'Provide a description',
  DESCRIPTION_LENGTH: 'Description must be Min. 1 char, Max. 50 chars.',
  NO_LOCATION: 'Provide at least one valid location',
  INVALID_JSON: 'This is not a valid location',
  MISSING_RELATIONSHIP: 'Select a relationship'
}

export const PARTICIPATION_TABLE_COLUMNS = [
  'UserID',
  'Times Earned',
  'Last Earned Date'
]

export const PARTICIPATION_FILTERS_KEYS = {
  SEARCH: 'search'
}

export const PARTICIPATION_MORE_BUTTON_LABELS = {
  DOWNLOAD_USERS: 'Download list of Users'
}

export const SEARCH_PARTICIPATION_ACTION = 'SEARCH_PARTICIPATION'

export const SEARCH_PARTICIPATION_ERROR_MSG =
  'Something went wrong while fetching participations. Please try again.'

export const DEFAULT_PROGRESS = 0

export const BASE_EARN_COUNT = 1
export const CAMPAIGN_EARNING_CONDITIONS_LIMIT = 10

export const LOCATION_DESCRIPTION_MIN_LENGTH = 1
export const LOCATION_DESCRIPTION_MAX_LENGTH = 50

export const LOCATION_PREVIEW_IMAGE_WIDTH = 1000
export const LOCATION_PREVIEW_IMAGE_HEIGHT = 400

export const MINIMUM_EARNING_UNIT_FOR_TIME_DISTINCT = 'DAY'

export const TIME_DISTINCT_UNIT_OPTIONS = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH'
}

export const RESET_CAMPAIGN_FIELDS_MAP: Record<
  string,
  {
    errors?: Partial<BaseCampaign>
    fields?: Partial<BaseCampaign>
  }
> = {
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.HAS_EARNING_LIMIT]: {
    errors: {
      earningCount: '',
      earnUnit: '',
      bucketRepetition: '',
      earnMax: ''
    },
    fields: {
      earningCount: '',
      earnUnit: '',
      bucketRepetition: '',
      earnMax: ''
    }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.HAS_SPECIFIC_DAYS]: {
    errors: { specificDays: '' as unknown as string[] },
    fields: { specificDays: [] }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.HAS_SPECIFIC_TIMES]: {
    errors: { specificTimes: '' as unknown as CampaignSpecificTime[] },
    fields: { specificTimes: [] }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.REQUIRE_PROVIDER]: {
    errors: { provider: [] },
    fields: { provider: [] }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.HAS_SPECIFIC_LOCATION]: {
    errors: { geoJson: [] },
    fields: { geoJson: [] }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.HAS_TIME_DISTINCT]: {
    errors: {
      timeDistinctCount: '',
      timeDistinctUnit: ''
    },
    fields: {
      timeDistinctCount: null,
      timeDistinctUnit: ''
    }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.MULTI_HAS_SPECIFIC_LOCATION_FOR_FIRST]: {
    errors: { geoJsonForFirst: [] },
    fields: { geoJsonForFirst: [] }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.MULTI_HAS_SPECIFIC_LOCATION_FOR_SECOND]: {
    errors: { geoJsonForSecond: [] },
    fields: { geoJsonForSecond: [] }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.HAS_SPECIFIC_PRODUCT]: {
    errors: { specificProductIDs: [] },
    fields: { specificProductIDs: [] }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.SEGMENT_USERS_ON_SURVEY_ANSWERS]: {
    fields: { segmentationRules: [] }
  },
  [CREATE_OR_UPDATE_CAMPAIGN_KEYS.HAS_PARTICIPATION_LIMIT]: {
    fields: { ParticipationLimitQuantity: null, ParticipationLimitUnit: null },
    errors: { ParticipationLimitQuantity: null, ParticipationLimitUnit: null }
  }
}

export const TIER_BEHAVIOR_FILTERS = {
  NO_FILTER: 'NO_FILTER',
  CUSTOM_FILTER: 'CUSTOM_FILTER',
  SQL_FILTER: 'SQL_FILTER'
}

export const TIER_CAMPAIGN_BEHAVIORS_FILTER_TYPES = [
  {
    key: TIER_BEHAVIOR_FILTERS.NO_FILTER,
    label: 'No Filter'
  },
  { key: TIER_BEHAVIOR_FILTERS.CUSTOM_FILTER, label: 'Custom Selection' },
  { key: TIER_BEHAVIOR_FILTERS.SQL_FILTER, label: 'SQL filter' }
]

export const CAMPAIGN_EXPIRE_ACTION_TYPES = {
  REDEMPTION: 'Redemption',
  CAMPAIGN: 'Campaign'
} as const

export type CAMPAIGN_EXPIRE_ACTION_TYPES_TYPE =
  (typeof CAMPAIGN_EXPIRE_ACTION_TYPES)[keyof typeof CAMPAIGN_EXPIRE_ACTION_TYPES]

export const CAMPAIGN_EXPIRE_ACTION_TYPES_RADIO = [
  {
    key: CAMPAIGN_EXPIRE_ACTION_TYPES.REDEMPTION,
    label: 'Making a Redemption'
  },
  {
    key: CAMPAIGN_EXPIRE_ACTION_TYPES.CAMPAIGN,
    label: 'Earning a Campaign'
  }
]
